module.exports = __webpack_public_path__ + "media/images/profile_check_3-cf7d9485a68983a2a425b034450a067f.png";